var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ad-error',{attrs:{"http-status-code":_vm.statusCode}},[_c('div',[(!_vm.isArchiveDetail)?_vm._t("product-detail-page",null,{"product":_vm.product}):_vm._e(),(_vm.isArchiveDetail)?_vm._t("archive-detail-page",null,{"product":_vm.product}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }